import { render, staticRenderFns } from "./ConfirmQuestion.vue?vue&type=template&id=7f670584"
import script from "./ConfirmQuestion.vue?vue&type=script&lang=js"
export * from "./ConfirmQuestion.vue?vue&type=script&lang=js"
import style0 from "./ConfirmQuestion.vue?vue&type=style&index=0&id=7f670584&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports